<template>
  <div class="mx-2">
    <div class="grid grid-cols-2 gap-x-5">
      <div class="w-full">
        <p class="font-medium text-gray-700">Current Password <span class="text-red-500">*</span></p>
        <div class="flex mt-1 items-center">
          <div class="w-full">
            <input
              class="bg-input text-sm text-gray-500 flex-grow outline-none px-3 py-2 w-full rounded placeholder-gray-300"
              type="password"
              placeholder="Insert your current password"
              v-model="password.old_password"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-x-5">
      <div class="sm:mr-2.5 mr-5 w-full">
        <p class="font-medium text-gray-700">New Password <span class="text-red-500">*</span></p>
        <div class="mt-1">
          <input @keyup="password.error = null" v-model="password.new_password" placeholder="Insert your new password" class="bg-input text-sm text-gray-500 flex-grow outline-none px-3 py-2 w-full rounded placeholder-gray-300" type="password">
          <PasswordStrength :toggle="true" :badge="false" v-model="password.new_password" :strength-meter-only="true"/>
          <span class="text-xs text-gray-400 mt-10">Use 8 ore more characters with a mix of letters, numbers & symbols.</span>
        </div>
      </div>
      <div class="sm:mr-2.5 md: mr-5 w-full">
        <p class="font-medium text-gray-700">Confirm New Password <span class="text-red-500">*</span></p>
        <div class="flex mt-1 items-center">
          <div class="w-full">
            <input
              class="bg-input text-sm text-gray-500 flex-grow outline-none px-3 py-2 w-full rounded placeholder-gray-300"
              @keyup="password.error = null"
              type="password"
              :placeholder="'Confirm New Password'"
              v-model="password.new_password_validation"
            />
            <div class="h-5 text-xs text-red-500 italic">
              {{ password.error }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="my-6">
      <button @click="changePassword()" :disabled="disabledButton" class="px-8 py-2 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50">
        Update Password
      </button>
    </div>
  </div>
</template>
<script>
  import { EventBus } from 'utils/event-bus';
  import { mapGetters } from 'vuex';
  /* Services ------------------------------------------------------- */
  import changePassword from 'services/account/changePassword';

  export default {
    data() {
      return {
        password: {
          new_password: '',
          new_password_validation: '',
          error: null,
        },
      };
    },
    components: {
      PasswordStrength: () => import('vue-password-strength-meter'),
    },
    computed: {
      ...mapGetters(['getProfile']),
      profile() {
        return this.getProfile;
      },
      disabledButton() {
        return (
          !this.password.old_password ||
          !this.password.new_password ||
          !this.password.new_password_validation
        );
      },
    },
    methods: {
      changePassword() {
        if (!this.password.new_password || this.password.new_password.length < 8) {
          this.error_msg =
            'Please enter a password at least 8 characters in length';
          return;
        }
        if (
          this.password.new_password !== this.password.new_password_validation
        ) {
          this.password.error =
            'New password and password validation must be the same';
          return null;
        }
        // changePassword refers to the service method import at the top of the file
        return changePassword({
          id: this.profile.id,
          old_password: this.password.old_password,
          new_password: this.password.new_password,
        })
          .then(() => {
            this.password.error = null;
            this.password.old_password = '';
            this.password.new_password = '';
            this.password.new_password_validation = '';
            const toast = {
              type: 'Success',
              message: 'You changed the password with success!',
              time: 5000,
            };
            EventBus.$emit('createToast', toast);
          })
          .catch((e) => {
            console.error(e);
            const toast = {
              type: 'Error',
              message: 'There was an error in changing password! Try again!',
              time: 5000,
            };
            EventBus.$emit('createToast', toast);
          });
      },
    },
  };
</script>

<style lang="css"></style>



// WEBPACK FOOTER //
// passwordTab.vue?d53cc33c